import { frappe } from "./frappeClient";

// Read Attendance list via REST resource API :contentReference[oaicite:4]{index=4}
export async function getMyAttendance({ fromDate, toDate, limit = 100 }) {
    // IMPORTANT:
    // If your Frappe permissions are correct, this should already be restricted
    // to the logged-in user's employee/attendance.
    const params = {
        fields: JSON.stringify(["name", "employee", "attendance_date", "status"]),
        order_by: "attendance_date desc",
        limit_page_length: limit
    };

    // Optional date filters
    if (fromDate && toDate) {
        params.filters = JSON.stringify([
            ["attendance_date", ">=", fromDate],
            ["attendance_date", "<=", toDate]
        ]);
    }

    const res = await frappe.get("/api/resource/Attendance", { params });
    return res.data?.data || [];
}
